export const baseUrl = 'https://easytipping.com/api/v1';   //Rana uzair  //live
// export const baseUrl = 'https://staging.easytipping.com/api/v1';   //Rana uzair  //argon server
// export const baseUrl = "http://10.3.1.206:5001/api/v1"; //Rana uzair  //argon server
// export const baseUrl = process.env.REACT_APP_BASE_URL; // live amazon server
// export const baseUrl = process.env.REACT_APP_BASE_URL; //sohaib bhai serveraaa
// export const baseUrl = process.env.REACT_APP_BASE_URL; //sohaib bhai serveraaa
